import { type CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserSessionService } from '#services';
import { AppRoles } from '#enums';

/**
 * Redirects ARES.ThirdParty and ARES.ThirdPartyAdmin users away from
 * restricted routes (e.g. /admin) to /asset-inventory.
 * Reads synchronously from localStorage — no network wait.
 */
export const externalUserGuard: CanActivateFn = () => {
    const sessionService = inject(UserSessionService);
    const router = inject(Router);

    const user = sessionService.currentUser();
    if (!user?.isExternal) return true;

    const isThirdParty = user.roles.some(
        r => r.roleId === AppRoles.ThirdParty || r.roleId === AppRoles.ThirdPartyAdmin
    );

    return isThirdParty ? router.createUrlTree(['/asset-inventory']) : true;
};
